import { useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
import { Pathname } from "../../../constants/pathnames/pathname";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from '@erpsquad/common/runtime';


export const ResetPassword = () => {
  const { resetPassword } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const tokenParam = searchParams.get("token");

    if (!tokenParam) {
      navigate(Pathname.LOGIN);
    } else {
      resetPassword({ token: tokenParam }, (response) => {
        if (!response) {
           navigate(Pathname.LOGIN);
        } else {
          if (response && response?.data && response?.data?.isValid) {
             navigate(Pathname.CHANGE_PASSWORD, { state: { token: tokenParam } });
          }
        }
      });
    }
  }, [searchParams, resetPassword, navigate]);

  return <Box>Resetting password, please wait...</Box>;
};